var HG_PPC_Maps = {
    'geocoder':null,
    'map': null,

    'getParameterByName': function(name, fallback) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? fallback : decodeURIComponent(results[1].replace(/\+/g, " "));
    },

     'initialize': function() {
        HG_PPC_Maps.geocoder = new google.maps.Geocoder();
        var state = HG_PPC_Maps.getParameterByName('state', 'nsw');
        var suburb_key = HG_PPC_Maps.getParameterByName('suburb', 'epping');
        var suburb = suburb_key.replace(/_/g,' ');
        var location = suburb+state;

        if (typeof location != 'undefined') {
            HG_PPC_Maps.geocoder.geocode( { 'address': location}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var latlng = new google.maps.LatLng(results[0].geometry.location);
                    var mapOptions = {
                        zoom: 13,
                        center: latlng,
                        disableDefaultUI: true
                    };
                    HG_PPC_Maps.map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
                    HG_PPC_Maps.map.setCenter(results[0].geometry.location);
                } else {
                    //do nothing
                }
            });
        }
    }
};


// WEBPACK FOOTER //
// ../legacy/src/legacy/js/HG_get_quotes_ppc.js